export default "__VITE_ASSET__Bc$FM8pq__"